<template>
  <div>
    <b-card v-if="ad">
      <template slot="header">
        Ad Approvals {{ ads.length }}
      </template>
      <h4>{{ ad.name }}</h4>
      <b-row>
        <b-col>
          <iframe :src="ad.iurl"/>
        </b-col>
        <b-col>
          <iframe :src="iframeAdSrc"/>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <b-btn class="m-5" variant="success" @click="rate('PREMIUM')">
            Premium
          </b-btn>
          <b-btn class="m-5" variant="primary" @click="rate('GENERAL')">
            General
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <b-btn class="m-3" variant="danger" @click="rate('LOW')">
            Low
          </b-btn>
          <b-btn class="m-3" variant="danger" @click="rate('BROKEN', 'Broken')">
            Broken
          </b-btn>
          <b-btn class="m-3" variant="danger" @click="rate('MALICIOUS', 'Malicious creative found')">
            Malicious
          </b-btn>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="ad" title="Creative source" class="mt-4">
      <b-form-textarea v-model="ad.html.trim()" rows="3" max-rows="10"></b-form-textarea>
    </b-card>
    <b-card v-else title="No Ads">
      <h4>No ads awaiting approval</h4>
    </b-card>
  </div>
</template>

<script>
    import {DemandApi} from '@/demand/api'

    export default {
        name: 'AdApprovals',
        created() {
            this.list();
        },
        data() {
            return {
                skip: 0,
                ads: []
            }
        },
        methods: {
            list() {
                DemandApi.approvalsList().then((list) => {
                    this.ads = list
                }).catch((e) => {
                    log.warn("Error listing ad approvals: " + e)
                    this.$notify.error("Error listing approvals")
                })
            },
            rate(quality, reason) {
                let ad = this.ad

                DemandApi.approvalSet(ad.name, quality, reason).then((r) => {
                    this.$notify.success("Rating submitted")
                    let ads = this.ads
                    ads.splice(ads.indexOf(ad), 1)
                }).catch((e) => {
                    this.$notify.error("Error rating ad: " + e)
                })
            }
        },
        computed: {
            ad() {
                let skip = this.skip
                let ads = this.ads

                if (skip > ads.length) {
                    skip = ads.length - 1
                }

                if (ads.length > skip) {
                    return ads[skip]
                }

                return null; /* no ads eh */
            },
            iframeAdSrc() {
                let ad = this.ad
                return ad == null ? null : 'http://direct.market-api.smrtb.com/preview/' + ad.name
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/pages/AdApprovals.vue